// Deterministic seeded RNG (mulberry32). The ONLY source of randomness in the
// engine — threaded through state so a (roomId, seed, clickSequence) triple
// reproduces a run byte-for-byte. See research/DECISIONS.md, cross-cutting #2.

export class RNG {
  private state: number;
  constructor(public readonly seed: number) {
    this.state = seed >>> 0;
  }
  /** next float in [0,1) */
  float(): number {
    let t = (this.state += 0x6d2b79f5);
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  }
  /** integer in [0, n) */
  int(n: number): number {
    return Math.floor(this.float() * n);
  }
  /** snapshot for replay/serialization */
  snapshot(): number {
    return this.state;
  }
  restore(state: number): void {
    this.state = state >>> 0;
  }
}
